module.exports = __webpack_public_path__ + "img/www.trustpilot.com.b40eadda.png";